"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createToolElapsedStore = exports.readToolElapsedData = exports.toolElapsedChunk = exports.TOOL_ELAPSED_DATA_TYPE = void 0;
exports.TOOL_ELAPSED_DATA_TYPE = 'data-tool-elapsed';
const toolElapsedChunk = (data) => ({
    type: exports.TOOL_ELAPSED_DATA_TYPE,
    data,
    transient: true,
});
exports.toolElapsedChunk = toolElapsedChunk;
const readToolElapsedData = (chunk) => {
    const part = chunk;
    if (part?.type !== exports.TOOL_ELAPSED_DATA_TYPE)
        return null;
    const data = part.data;
    if (typeof data?.toolCallId !== 'string' || !data.toolCallId)
        return null;
    if (!Number.isFinite(data.elapsedMs) || data.elapsedMs < 0)
        return null;
    return { toolCallId: data.toolCallId, elapsedMs: data.elapsedMs };
};
exports.readToolElapsedData = readToolElapsedData;
const createToolElapsedStore = () => {
    const byToolCall = new Map();
    return {
        record: ({ toolCallId, elapsedMs }) => {
            byToolCall.set(toolCallId, elapsedMs);
        },
        read: (toolCallId) => byToolCall.get(toolCallId) ?? null,
    };
};
exports.createToolElapsedStore = createToolElapsedStore;
//# sourceMappingURL=tool-elapsed.js.map